import React from 'react';
import {DesktopPage} from '../../../clean-components/desktop-page/desktop-page';
import StopDetailComponent from '../../../clean-components/stop-detail/stop-detail.component';

export const StopDetailDesktop = () => {
    return <DesktopPage>
        <StopDetailComponent buttons={['go', 'report']}/>
    </DesktopPage>;
};
